import {toInt} from '@/library/math';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const CustomerTerminationList       = () => import('../../views/customer/termination/CustomerTerminationList.vue');
const CustomerTerminationConfirmationList       = () => import('../../views/customer/termination/CustomerTerminationConfirmationList.vue');
const CustomerTerminationConfirmationTextList       = () => import('../../views/customer/termination/CustomerTerminationConfirmationTextList.vue');
const CustomerTerminationConfirmationTextEdit       = () => import('../../views/customer/termination/CustomerTerminationConfirmationTextEdit.vue');

const meta: MetaData = {
    module: 'customer',
};

let termination: RouteRecordRaw[] = [
    {
        name: 'customer-termination-list',
        path: '/customer/termination/list',
        meta,
        component: CustomerTerminationList,
    },
    {
        name: 'customer-termination-confirmation-list',
        path: '/customer/termination/termination-confirmation-list',
        meta,
        component: CustomerTerminationConfirmationList,
    },
    {
        name: 'customer-termination-confirmation-text-list',
        path: '/customer/termination/termination-confirmation-text-list',
        meta,
        component: CustomerTerminationConfirmationTextList,
    },
    {
        name: 'customer-termination-confirmation-text-add',
        path: '/customer/termination/confirmation-text-add',
        meta,
        component: CustomerTerminationConfirmationTextEdit,
    },
    {
        name: 'customer-termination-confirmation-text-edit',
        path: '/customer/termination/confirmation-text-edit/:id',
        component: CustomerTerminationConfirmationTextEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        path: '/customer/termination/:wildcard*',
        redirect: {name: 'customer-termination-list'},
    },
];

export default termination;
